import {Component} from '@angular/core';

@Component({
  selector: 'as-empty-list',
  templateUrl: './empty-list.component.html'
})
export class EmptyListComponent {
}
